import { render, staticRenderFns } from "./compare.vue?vue&type=template&id=39c07c60&scoped=true"
import script from "./compare.vue?vue&type=script&lang=js"
export * from "./compare.vue?vue&type=script&lang=js"
import style0 from "./compare.vue?vue&type=style&index=0&id=39c07c60&prod&lang=css"
import style1 from "./compare.vue?vue&type=style&index=1&id=39c07c60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c07c60",
  null
  
)

export default component.exports